module.exports = __webpack_public_path__ + "static/st-jamess-palace-penny-farthing-bc92548d083f1918c9f9b24de7079438.jpg";